import React,{ useState, useEffect, useRef} from "react";
import { Row,  Card, Col, Container, CardBody, CardHeader, Button, Modal, ModalBody, ModalHeader, Alert} from "shards-react";
import { ProtectedRoute } from "../../../ProtectedRoute";
import AdminService from "../../../flux/services/AdminService";
import DataTable from "react-data-table-component";
import PageTitle from "../../../components/common/PageTitle";
import tableCustomerStyles from "../../../utils/tableCustomStyles";
import ScoreService from "../../../flux/services/ScoreService";
import ScoreFileDetailsCSV from "./ScoreFileDetailsCSV";
 
export default function ScoreFile (props)
{

  const today = new Date();
  const profile = props.profile;
  let [refresh, setRefresh] = useState({ refresh: props.refresh})
  const [state, setState]= useState({
    memberId: props.memberId,
    view: props.view,
    profile: props.profile
  });


  const [data, setData] = useState(null);

  useEffect(() => {
    let ismounted = true;
//    async function getClearingNames(memId, profile){

      try {

        let data = null;
        // set loading to true before calling API
          /*data = */ AdminService.getMemberRoundTable().then(data => {if (ismounted) setData(data)});

        /*setData(data);*/

      } catch (error) {
        console.log(error);
      }
   
  //  getClearingNames(state.memberId, profile);
    return () => { ismounted = false };

  }, [refresh, props.refresh]
  );


  const columns = [
    {
      name: 'Member Id',
      selector: data => data.member_id.toString(),
      sortable: true,
      width: '10%'
    },
    {
      name: 'Member',
      selector: data => data.name.toString(),
      sortable: true,
      width: '25%'
    },
    {
      name: 'Contact Name',
      sortable: true,
      selector: data => data.contact_first_name + ' ' + data.contact_last_name,
      width: '25%'
    },
    {
      name: ('Email'),
      selector: data => data.email,
      sortable: true,
      width: '25%'
    },
    {
      name: ('Download'),
      // cell: data => (<button type="button" id={data.member_id} class="btn btn-link" onClick={ViewReport.bind(this)}>View Report</button>),
      cell: data => (<ScoreFileDetailsCSV memberId={data.member_id} fileName={data.member_id.toString() + '_' +  ((today.getFullYear() * 100) + ((today.getMonth() + 1))).toString() + ".csv"}></ScoreFileDetailsCSV>),
      width: '15%'
    }
    ]
    
  const MemberDataTable = (props) =>
  {

    if (!data) return (
      <span>Data not available</span>
    );

    return (
        <Row className="px-1">
            <DataTable 
                  customStyles={tableCustomerStyles} columns={columns}
              data={data}
              ></DataTable>
        </Row>)
  }


  
  return (
     <ProtectedRoute>
        <Container className="main-content-container px-3 pb-3">
        
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="Meeting Name Report"
            className="text-sm-left"
          />
          </Row>
    <Card small className="mb-3">
     
        <CardHeader className="border-bottom">
          <h5>
            A La Carte Invoice
          </h5>
        </CardHeader>
        <CardBody>
        
        
        <Col>
          
          <CardHeader className="border-bottom mb-2">
            
          <div className="text-center fs-6 fw-bold">Invoices</div>
          </CardHeader>
          <MemberDataTable
          
          data={props}></MemberDataTable>
        </Col>
         
        </CardBody>
    </Card>
    </Container>
        </ProtectedRoute>
  )
}